// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { InstrumentTypes, InstrumentTypesColor, getInstrumentTypeShortName } from '@shared/utils/Instruments/InstrumentTypes';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
export class SymbolLookupViewItemHelper {
    static getInstrumentTypeShortForInstrument(instrument) {
        const instrumentType = SymbolLookupViewItemHelper.getCorrectedInstrumentTypeForDisplay(instrument.InstrType, instrument.CFD);
        return getInstrumentTypeShortName(instrumentType);
    }
    static getInstrumentTypeShort(type) {
        return type === InstrumentTypes.SPOT
            ? InstrumentUtils.UseFuturesInsteadSpotShortName()
            : getInstrumentTypeShortName(type);
    }
    static getInstrumentTypeColorForInstrument(instrument) {
        const instrumentType = SymbolLookupViewItemHelper.getCorrectedInstrumentTypeForDisplay(instrument.InstrType, instrument.CFD);
        return InstrumentTypesColor[instrumentType];
    }
    static getInstrumentTypeColor(type) {
        return type === InstrumentTypes.SPOT
            ? InstrumentUtils.UseFuturesInsteadSpotColor()
            : InstrumentTypesColor[type];
    }
    static getCorrectedInstrumentTypeForDisplay(instrumentType, cfd = false) {
        if (cfd === true) {
            if (instrumentType === InstrumentTypes.FUTURES) {
                return InstrumentTypes.CFD_FUTURES;
            }
            if (instrumentType === InstrumentTypes.EQUITIES) {
                return InstrumentTypes.EQUITIES_CFD;
            }
        }
        if (instrumentType === InstrumentTypes.SPOT) {
            return InstrumentUtils.UseFuturesInsteadSpot() ? InstrumentTypes.FUTURES : InstrumentTypes.SPOT;
        } /* else if (instrumentType === InstrumentTypes.CONTINIOUS_FUTURES) {
            return InstrumentTypes.FUTURES;
        } */
        else {
            return instrumentType;
        }
    }
}
